import React from "react";

const OrderAssigned = () => {
    return (
        <p>order</p>
    )
};

export default OrderAssigned;